import {
  CATALOG_FOOD_KIND_BRANDED,
  CATALOG_FOOD_SOURCE_EFORT,
  CATALOG_FOOD_SOURCE_OPEN_SOURCE,
  normalizeCatalogFoodKind,
  normalizeCatalogFoodSource,
} from "../foods/supabaseFoodCatalogShared";

const LEGACY_CATALOG_SOURCE_VALUES = new Set([
  CATALOG_FOOD_SOURCE_EFORT,
  CATALOG_FOOD_SOURCE_OPEN_SOURCE,
  "SUPABASE_GENERIC_FOOD",
  "GENERIC_SUPPLEMENT",
  "BEDCA",
]);

function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function getCustomCoachLabel(food) {
  const parts = [food?.brand, food?.store]
    .filter(hasText)
    .map((value) => value.trim());

  return parts.length > 0 ? parts.join("  •  ") : "";
}

function isCatalogSourceValue(value) {
  const normalizedValue = String(value ?? "").trim().toUpperCase();
  return LEGACY_CATALOG_SOURCE_VALUES.has(normalizedValue);
}

function isCatalogRuntimeItem(food) {
  return (
    food?._catalog === true ||
    food?.databaseKey === "catalog" ||
    hasText(food?.catalogFoodId) ||
    hasText(food?.linkedCatalogFoodId) ||
    hasText(food?.origin?.catalog_food_id) ||
    isCatalogSourceValue(food?.source) ||
    isCatalogSourceValue(food?.catalogSource)
  );
}

function isCoachRuntimeItem(food) {
  if (isCatalogRuntimeItem(food)) {
    return false;
  }

  return (
    food?.databaseKey === "createdByMe" ||
    food?.source === "coach_created" ||
    hasText(food?.foodId) ||
    hasText(food?.origin?.coach_food_id)
  );
}

function getCatalogRuntimeLabel(food, t) {
  const catalogKind = normalizeCatalogFoodKind(
    food?.catalog_kind ?? food?.catalogKind,
    food,
  );
  if (catalogKind === CATALOG_FOOD_KIND_BRANDED) {
    if (hasText(food?.brand)) {
      return food.brand.trim();
    }

    if (hasText(food?.store)) {
      return food.store.trim();
    }
  }

  const source = normalizeCatalogFoodSource(food?.source ?? food?.catalogSource, {
    defaultSource: CATALOG_FOOD_SOURCE_OPEN_SOURCE,
  });

  return source === CATALOG_FOOD_SOURCE_EFORT
    ? (typeof t === "function"
        ? t("catalogSourceEfort-string", "EFORT")
        : "EFORT")
    : (typeof t === "function"
        ? t("catalogSourceOpenSource-string", "OPEN SOURCE")
        : "OPEN SOURCE");
}

export function getEditorFoodSourceLabel(food, t) {
  if (!food || typeof food !== "object") {
    return "";
  }

  if (isCatalogRuntimeItem(food)) {
    return getCatalogRuntimeLabel(food, t);
  }

  const customCoachLabel = getCustomCoachLabel(food);
  if (customCoachLabel) {
    return customCoachLabel;
  }

  if (isCoachRuntimeItem(food)) {
    return typeof t === "function"
      ? t("createdByMe-string", "Created by me")
      : "Created by me";
  }

  return hasText(food?.sourceLabel) ? food.sourceLabel.trim() : "";
}
